import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

export const userManagementAccessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const userRoles = authService.getUserRoles();

  if (
    userRoles &&
    (userRoles.includes('Admin') || userRoles.includes('Branch Admin'))
  ) {
    return true;
  } else {
    router.navigate(['/dashboard']);
    return false;
  }
};
